(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["chic-video-carousel"] && !Shopify.designMode) return;
  try {
    
  const initializeChicVideoCarousel = (root) => {
    if (!root || root.dataset.carouselReady === 'true') return;

    root.dataset.carouselReady = 'true';
    const track = root.querySelector('[data-carousel-track]');
    const previous = root.querySelector('[data-carousel-previous]');
    const next = root.querySelector('[data-carousel-next]');
    if (!track || !previous || !next) return;

    const updateButtons = () => {
      const maxScroll = Math.max(0, track.scrollWidth - track.clientWidth);
      previous.disabled = track.scrollLeft <= 2;
      next.disabled = track.scrollLeft >= maxScroll - 2;
    };

    const scrollOneCard = (direction) => {
      const slide = track.querySelector('[data-carousel-slide]');
      if (!slide) return;
      const gap = parseFloat(window.getComputedStyle(track).columnGap) || 0;
      track.scrollBy({ left: direction * (slide.getBoundingClientRect().width + gap), behavior: 'smooth' });
    };

    previous.addEventListener('click', () => scrollOneCard(-1));
    next.addEventListener('click', () => scrollOneCard(1));
    track.addEventListener('scroll', updateButtons, { passive: true });
    window.addEventListener('resize', updateButtons, { passive: true });
    updateButtons();

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      root.querySelectorAll('video[autoplay]').forEach((video) => video.pause());
    }
  };

  document.querySelectorAll('.chic-video-carousel').forEach(initializeChicVideoCarousel);

  document.addEventListener('shopify:section:load', (event) => {
    const root = event.target.querySelector('.chic-video-carousel');
    initializeChicVideoCarousel(root);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
